import { render, staticRenderFns } from "./SessionOver.vue?vue&type=template&id=18a35833&scoped=true&"
import script from "./SessionOver.vue?vue&type=script&lang=ts&"
export * from "./SessionOver.vue?vue&type=script&lang=ts&"
import style0 from "./SessionOver.vue?vue&type=style&index=0&id=18a35833&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a35833",
  null
  
)

export default component.exports